{
  "labels": {
    "paste": "Вставити",
    "pasteAsPlaintext": "Вставити як простий текст",
    "pasteCharts": "Вставити діаграми",
    "selectAll": "Вибрати все",
    "multiSelect": "Додати елемент до вибраного",
    "moveCanvas": "Перемістити полотно",
    "cut": "Вирізати",
    "copy": "Копіювати",
    "copyAsPng": "Копіювати як PNG",
    "copyAsSvg": "Копіювати як SVG",
    "copyText": "Копіювати в буфер обміну як текст",
    "copySource": "",
    "convertToCode": "",
    "bringForward": "Перемістити вперед",
    "sendToBack": "На задній план",
    "bringToFront": "На передній план",
    "sendBackward": "Перемістити назад",
    "delete": "Видалити",
    "copyStyles": "Копіювати стилі",
    "pasteStyles": "Вставити стилі",
    "stroke": "Контур",
    "background": "Тло",
    "fill": "Заповнити",
    "strokeWidth": "Товщина контуру",
    "strokeStyle": "Стиль контуру",
    "strokeStyle_solid": "Суцільний",
    "strokeStyle_dashed": "Пунктир",
    "strokeStyle_dotted": "Крапки",
    "sloppiness": "Охайність",
    "opacity": "Прозорість",
    "textAlign": "Вирівнювання тексту",
    "edges": "Краї",
    "sharp": "Гострі",
    "round": "Круглі",
    "arrowheads": "Закінчення стрілки",
    "arrowhead_none": "Жоден",
    "arrowhead_arrow": "Стрілка",
    "arrowhead_bar": "Колона",
    "arrowhead_circle": "",
    "arrowhead_circle_outline": "",
    "arrowhead_triangle": "Трикутник",
    "arrowhead_triangle_outline": "",
    "arrowhead_diamond": "",
    "arrowhead_diamond_outline": "",
    "fontSize": "Розмір шрифту",
    "fontFamily": "Шрифт",
    "addWatermark": "Додати «Накреслене в Excalidraw»",
    "handDrawn": "Ручний апарат",
    "normal": "Звичайний",
    "code": "Код",
    "small": "Малий",
    "medium": "Середній",
    "large": "Великий",
    "veryLarge": "Дуже великий",
    "solid": "Суцільна",
    "hachure": "Штриховка",
    "zigzag": "Зиґзаґ",
    "crossHatch": "Перехресна штриховка",
    "thin": "Тонкий",
    "bold": "Жирний",
    "left": "Зліва",
    "center": "По центру",
    "right": "Справа",
    "extraBold": "Товстий",
    "architect": "Архітектор",
    "artist": "Художник",
    "cartoonist": "Карикатурист",
    "fileTitle": "Назва файла",
    "colorPicker": "Палітра кольорів",
    "canvasColors": "Використовується на полотні",
    "canvasBackground": "Тло полотна",
    "drawingCanvas": "Полотно",
    "layers": "Шари",
    "actions": "Дії",
    "language": "Мова",
    "liveCollaboration": "Спільна робота наживо...",
    "duplicateSelection": "Дублювати",
    "untitled": "Без назви",
    "name": "Ім’я",
    "yourName": "Ваше ім’я",
    "madeWithExcalidraw": "Накреслене в Excalidraw",
    "group": "Групувати виділене",
    "ungroup": "Розгрупувати виділене",
    "collaborators": "Співавтори",
    "showGrid": "Показати сітку",
    "addToLibrary": "Додати до бібліотеки",
    "removeFromLibrary": "Видалити з бібліотеки",
    "libraryLoadingMessage": "Завантажити бібліотеку…",
    "libraries": "Всі бібліотеки",
    "loadingScene": "Завантаження сцени…",
    "align": "Вирівнювання",
    "alignTop": "Вирівняти по верхньому краю",
    "alignBottom": "Вирівняти по нижньому краю",
    "alignLeft": "Вирівняти по лівому краю",
    "alignRight": "Вирівнювання по правому краю",
    "centerVertically": "Центрувати по вертикалі",
    "centerHorizontally": "Центрувати по горизонталі",
    "distributeHorizontally": "Розподілити по горизонталі",
    "distributeVertically": "Розподілити вертикально",
    "flipHorizontal": "Віддзеркалити горизонтально",
    "flipVertical": "Віддзеркалити вертикально",
    "viewMode": "Режим перегляду",
    "share": "Поділитися",
    "showStroke": "Показати палітру для контура",
    "showBackground": "Показати палітру для фону",
    "toggleTheme": "Перемкнути тему",
    "personalLib": "Персональна бібліотека",
    "excalidrawLib": "Бібліотека Excalidraw",
    "decreaseFontSize": "Зменшити розмір шрифту",
    "increaseFontSize": "Збільшити розмір шрифту",
    "unbindText": "Відв'язати текст",
    "bindText": "Прив’язати текст до контейнера",
    "createContainerFromText": "Огорнути текст у контейнер",
    "link": {
      "edit": "Редагування посилання",
      "editEmbed": "Редагування посилання і вкладення",
      "create": "Створити посилання",
      "createEmbed": "Створити посилання і вкладення",
      "label": "Посилання",
      "labelEmbed": "Посилання і вкладення",
      "empty": "Посилання відсутнє"
    },
    "lineEditor": {
      "edit": "Редагувати лінію",
      "exit": "Закінчити редагування лінії"
    },
    "elementLock": {
      "lock": "Блокувати",
      "unlock": "Розблокувати",
      "lockAll": "Заблокувати все",
      "unlockAll": "Розблокувати все"
    },
    "statusPublished": "Опубліковано",
    "sidebarLock": "Не закривати бокове меню",
    "selectAllElementsInFrame": "Обрати всі елементи у фреймі",
    "removeAllElementsFromFrame": "Видалити всі елементи з фрейму",
    "eyeDropper": "Вибрати колір з полотна",
    "textToDiagram": "",
    "prompt": ""
  },
  "library": {
    "noItems": "Тут поки пусто...",
    "hint_emptyLibrary": "Виберіть об'єкт на полотні, щоб додати його сюди або встановіть бібліотеку з публічного репозиторію, що нижче.",
    "hint_emptyPrivateLibrary": "Виберіть елемент на полотні, щоб додати його сюди."
  },
  "buttons": {
    "clearReset": "Очистити полотно",
    "exportJSON": "Експорт у файл",
    "exportImage": "Експорт зображення...",
    "export": "Зберегти як...",
    "copyToClipboard": "Скопіювати до буферу обміну",
    "save": "Зберегти до поточного файлу",
    "saveAs": "Зберегти як",
    "load": "Відкрити",
    "getShareableLink": "Отримати посилання",
    "close": "Закрити",
    "selectLanguage": "Обрати мову",
    "scrollBackToContent": "Повернутися до вмісту",
    "zoomIn": "Збільшити",
    "zoomOut": "Зменшити",
    "resetZoom": "Скинути масштаб",
    "menu": "Меню",
    "done": "Готово",
    "edit": "Редагувати",
    "undo": "Відмінити",
    "redo": "Повторити",
    "resetLibrary": "Очистити бібліотеку",
    "createNewRoom": "Створити нову кімнату",
    "fullScreen": "Повноекранний режим",
    "darkMode": "Темна тема",
    "lightMode": "Світла тема",
    "zenMode": "Режим Дзен",
    "objectsSnapMode": "",
    "exitZenMode": "Вийти з дзен-режиму",
    "cancel": "Скасувати",
    "clear": "Очистити",
    "remove": "Видалити",
    "embed": "Перемкнути вкладення",
    "publishLibrary": "Опублікувати",
    "submit": "Надіслати",
    "confirm": "Підтвердити",
    "embeddableInteractionButton": "Натисніть для взаємодії"
  },
  "alerts": {
    "clearReset": "Це очистить все полотно. Впевнені?",
    "couldNotCreateShareableLink": "Не вдалося створити посилання.",
    "couldNotCreateShareableLinkTooBig": "Не вдалося створити посилання для обміну: сцена занадто велика",
    "couldNotLoadInvalidFile": "Файл з помилками не відкрився",
    "importBackendFailed": "Імпортування невдале.",
    "cannotExportEmptyCanvas": "Не вийшло експортувати пусте полотно.",
    "couldNotCopyToClipboard": "Не вдалося скопіювати до буфера обміну.",
    "decryptFailed": "Не вдалося розшифрувати дані.",
    "uploadedSecurly": "Це завантаження було захищене наскрізним шифруванням, а це означає що сервер Excalidraw та інші не зможуть прочитати вміст.",
    "loadSceneOverridePrompt": "Завантаження зовнішнього креслення замінить ваш наявний контент. Продовжити?",
    "collabStopOverridePrompt": "Зупинка сесії перезапише ваш попередній, локально збережений малюнок. Ви впевнені?\n\n(Якщо ви хочете зберегти локальний малюнок, просто закрийте замість нього вкладку браузера.)",
    "errorAddingToLibrary": "Не вдалося додати елемент до бібліотеки",
    "errorRemovingFromLibrary": "Не вдалося видалити елемент з бібліотеки",
    "confirmAddLibrary": "Це призведе до додавання {{numShapes}} фігур до вашої бібліотеки. Ви впевнені?",
    "imageDoesNotContainScene": "Виглядає ніби зображення не містить корисної інформації. Ви увімкнули вбудовування сцени при експорті?",
    "cannotRestoreFromImage": "Сцена не може бути відновлена з цього файлу зображення",
    "invalidSceneUrl": "Не вдалося імпортувати сцену з наданого URL. Він або недоформований, або не містить дійсних даних Excalidraw JSON.",
    "resetLibrary": "Це призведе до очищення бібліотеки. Ви впевнені?",
    "removeItemsFromsLibrary": "Видалити {{count}} елемент(ів) з бібліотеки?",
    "invalidEncryptionKey": "Ключ шифрування повинен бути довжиною до 22 символів. Спільну роботу вимкнено.",
    "collabOfflineWarning": "Немає підключення до Інтернету.\nВаші зміни не будуть збережені!"
  },
  "errors": {
    "unsupportedFileType": "Непідтримуваний тип файлу.",
    "imageInsertError": "Не вдалося вставити зображення. Повторіть спробу пізніше...",
    "fileTooBig": "Занадто великий розмір файлу, максимальний розмір файлу {{maxSize}}.",
    "svgImageInsertError": "Не вдалося вставити SVG-зображення. Помилка розмітки SVG.",
    "failedToFetchImage": "",
    "invalidSVGString": "Недійсний SVG.",
    "cannotResolveCollabServer": "Не вдалося приєднатися до сервера. Перезавантажте сторінку та повторіть спробу.",
    "importLibraryError": "Не вдалося завантажити бібліотеку",
    "collabSaveFailed": "Не вдалося зберегти у базу даних сервера. Якщо проблеми не зникнуть, Вам слід зберегти файл локально, щоб не втратити роботу.",
    "collabSaveFailed_sizeExceeded": "Полотно завелике! Не вдалося зберегти у базу даних сервера. Вам слід зберегти файл локально, щоб не втратити свою роботу.",
    "imageToolNotSupported": "",
    "brave_measure_text_error": {
      "line1": "Ви використовуєте браузер Brave з увімкненим налаштуванням <bold>Агресивного Блокування Розпізнавання Пристрою</bold>.",
      "line2": "Це може нашкодити <bold>текстовим елементам</bold> у ваших малюнках.",
      "line3": "Ми наполегливо рекомендуємо вимкнути це налаштування. Виконайте наступні <link>кроки</link>, щоб виправити це.",
      "line4": "Якщо вимкнення цього параметра не вирішує показ текстових елементів, тоді створіть, будь ласка, <issueLink>запит на розв'язання проблеми</issueLink> на нашому GitHub або напишіть нам у <discordLink>Discord</discordLink>"
    },
    "libraryElementTypeError": {
      "embeddable": "Вбудовані елементи не можна додати в бібліотеку.",
      "iframe": "",
      "image": "Підтримка додавання зображень в бібліотеку найближчим часом!"
    },
    "asyncPasteFailedOnRead": "",
    "asyncPasteFailedOnParse": "",
    "copyToSystemClipboardFailed": ""
  },
  "toolBar": {
    "selection": "Виділення",
    "image": "Вставити зображення",
    "rectangle": "Прямокутник",
    "diamond": "Ромб",
    "ellipse": "Еліпс",
    "arrow": "Стрілка",
    "line": "Лінія",
    "freedraw": "Малювати",
    "text": "Текст",
    "library": "Бібліотека",
    "lock": "Залишити обраний інструмент після креслення",
    "penMode": "Режим пера - запобігання дотику",
    "link": "Додати/Оновити посилання для вибраної форми",
    "eraser": "Очищувач",
    "frame": "Інструмент фрейму",
    "magicframe": "",
    "embeddable": "Веб вкладення",
    "laser": "",
    "hand": "Рука (інструмент для панорамування)",
    "extraTools": "Інші інструменти",
    "mermaidToExcalidraw": "",
    "magicSettings": ""
  },
  "headings": {
    "canvasActions": "Дії з полотном",
    "selectedShapeActions": "Вибрані дії з фігурою",
    "shapes": "Фігури"
  },
  "hints": {
    "canvasPanning": "Щоб перемістити полотно, утримуйте коліщатко миші або пробіл під час перетягування, або скористайтеся інструментом Рука",
    "linearElement": "Натисніть щоб додати кілька точок. Перетягніть щоб намалювати одну лінію",
    "freeDraw": "Натисніть і потягніть, відпустіть коли завершите",
    "text": "Порада: можна також додати текст, двічі клацнувши по будь-якому місці інструментом вибору",
    "embeddable": "Клікніть та перетягніть для створення вбудованого вебсайту",
    "text_selected": "Подвійний клік або натисніть клавішу ENTER, щоб редагувати текст",
    "text_editing": "Натисніть клавішу Escape або Ctrl/Cmd+ENTER, щоб завершити редагування",
    "linearElementMulti": "Натисніть на останню точку, клацніть Esc або Enter щоб завершити",
    "lockAngle": "Ви можете обмежити кут, утримуюючи SHIFT",
    "resize": "Ви можете зберегти пропорції, утримуючи SHIFT під час зміни розміру,\nутримуйте ALT для змінення розміру від центру",
    "resizeImage": "Ви можете змінювати розміри утримуючи клавішу SHIFT, втримуйте клавішу ALT щоб змінювати розмір відносно центру",
    "rotate": "Ви можете обмежити кути, утримуючи SHIFT під час обертання",
    "lineEditor_info": "Утримуйте CtrlOrCmd і двічі клацніть або натисніть CtrlOrCmd + Enter, щоб редагувати цятки",
    "lineEditor_pointSelected": "Натисніть Delete для видалення точку (точок), або Ctrl/Cmd+D для дублювання, перетаскування працює як звично",
    "lineEditor_nothingSelected": "Виберіть точку для редагування (втримуйте клавішу SHIFT для вибору кількох точок), або клавішу Alt для додавання нових точок",
    "placeImage": "Клацніть, щоб розмістити зображення, або натисніть та потягніть щоб змінити його розмір",
    "publishLibrary": "Опублікувати свою власну бібліотеку",
    "bindTextToElement": "Натисніть Enter, щоб додати текст",
    "deepBoxSelect": "Втримуйте Ctrl/Cmd для глибокого виділення та щоб попередити перетягування",
    "eraserRevert": "Втримуйте клавішу Alt, щоб повернути елементи позначені для видалення",
    "firefox_clipboard_write": "Цю функцію можна ввімкнути, встановивши значення \"true\" для налаштування \"dom.events.asyncClipboard.clipboardItem\". Перейдіть на сторінку «about:config», щоб змінити налаштування браузера у Firefox.",
    "disableSnapping": ""
  },
  "canvasError": {
    "cannotShowPreview": "Не вдається показати попередній перегляд",
    "canvasTooBig": "Полотно може бути завеликим.",
    "canvasTooBigTip": "Порада: спробуйте підсунути найвіддаленіші елементи ближче один до одного."
  },
  "errorSplash": {
    "headingMain": "Сталася помилка. Спробуйте <button>перезавантажити сторінку.</button>",
    "clearCanvasMessage": "Якщо перезавантаження не допоможе, спробуйте <button>очистити полотно.</button>",
    "clearCanvasCaveat": " Це призведе до втрати роботи ",
    "trackedToSentry": "Помилка з ідентифікатором {{eventId}} було відслідковано в нашій системі.",
    "openIssueMessage": "Ми були дуже обережні, щоб не включати інформацію про ваші сцени в текст помилки. Якщо ваша сцена не була приватна, будь ласка, розгляньте можливість продовження на нашому <button>трекер помилок.</button> Будь ласка, додайте інформацію нижче, скопіюючи і вставляючи у GitHub issue.",
    "sceneContent": "Вміст сцени:"
  },
  "roomDialog": {
    "desc_intro": "Ви можете запросити людей для спільної роботи.",
    "desc_privacy": "Не хвилюйтеся, сесія захищена наскрізним шифруванням, тому ваше креслення залишиться приватним. Навіть наш сервер не побачить вашу роботу.",
    "button_startSession": "Почати сесію",
    "button_stopSession": "Закрити сесію",
    "desc_inProgressIntro": "Сесія спільної роботи над кресленням триває.",
    "desc_shareLink": "Поділіться цим посиланням з будь-ким для спільної роботи:",
    "desc_exitSession": "Зупинка сесії відключить вас від кімнати, але ви зможете продовжити роботу з полотном локально. Зверніть увагу, що це не вплине на інших людей, і вони все одно зможуть працювати над їх версією.",
    "shareTitle": "Приєднатися до сеансу спільної роботи на Excalidraw"
  },
  "errorDialog": {
    "title": "Помилка"
  },
  "exportDialog": {
    "disk_title": "Зберегти на диск",
    "disk_details": "Експорт даних сцени в файл, з якого можна імпортувати пізніше.",
    "disk_button": "Зберегти до файлу",
    "link_title": "Доступ за посиланням",
    "link_details": "Експортувати як посилання тільки для читання.",
    "link_button": "Експортувати у посилання",
    "excalidrawplus_description": "Збережіть сцену у вашому обліковому записі Excalidraw+.",
    "excalidrawplus_button": "Експортувати",
    "excalidrawplus_exportError": "Не вдалося експортувати у Excalidraw+..."
  },
  "helpDialog": {
    "blog": "Наш блог",
    "click": "натиснути",
    "deepSelect": "Глибокий вибір",
    "deepBoxSelect": "Глибоке виділення в межах рамки, та обмеження перетягування",
    "curvedArrow": "Крива стрілка",
    "curvedLine": "Крива лінія",
    "documentation": "Документація",
    "doubleClick": "подвійний клік",
    "drag": "перетягнути",
    "editor": "Редактор",
    "editLineArrowPoints": "Редагувати лінію/стрілки",
    "editText": "Редагувати текст / додати позначку",
    "github": "Знайшли помилку? Повідомте",
    "howto": "Дотримуйтесь наших інструкцій",
    "or": "або",
    "preventBinding": "Запобігти зв'язування зі стрілками",
    "tools": "Інструменти",
    "shortcuts": "Гарячі клавіші",
    "textFinish": "Завершити редагування (текстовий редактор)",
    "textNewLine": "Додати новий рядок (текстовий редактор)",
    "title": "Допомога",
    "view": "Вигляд",
    "zoomToFit": "Збільшити щоб умістити всі елементи",
    "zoomToSelection": "Наблизити вибране",
    "toggleElementLock": "Заблокувати/розблокувати вибране",
    "movePageUpDown": "Пересунути сторінку вгору/вниз",
    "movePageLeftRight": "Пересунути сторінку вліво/вправо"
  },
  "clearCanvasDialog": {
    "title": "Очистити полотно"
  },
  "publishDialog": {
    "title": "Опублікувати бібліотеку",
    "itemName": "Назва елементу",
    "authorName": "Ім'я автора",
    "githubUsername": "Ім'я користувача Github",
    "twitterUsername": "Ім'я користувача Твитер",
    "libraryName": "Назва бібліотеки",
    "libraryDesc": "Опис бібліотеки",
    "website": "Вебсайт",
    "placeholder": {
      "authorName": "Ваше ім'я або ім'я користувача",
      "libraryName": "Назва вашої бібліотеки",
      "libraryDesc": "Опис вашої бібліотеки, щоб допомогти людям зрозуміти її використання",
      "githubHandle": "Ім'я користувача в GitHub (необов'язково), щоб ви могли редагувати бібліотеку під час перевірки",
      "twitterHandle": "Ім'я користувача у Twitter (необов'язково), щоб ми могли згадати вас під час промоції у Twitter",
      "website": "Посилання на ваш особистий сайт або інший сайт (опціонально)"
    },
    "errors": {
      "required": "Обов’язково",
      "website": "Введіть дійсну URL-адресу"
    },
    "noteDescription": "Подати бібліотеку, щоб вона була включена до <link>публічного репозиторія бібліотек</link>для інших людей, для використання у їхніх полотнах.",
    "noteGuidelines": "Спочатку бібліотека повинна бути підтверджена. Будь ласка, прочитайте <link>настанови</link> перед відправкою. Вам знадобиться обліковий запис на GitHub, щоб колаборувати та вносити зміни, але це не обов'язково.",
    "noteLicense": "Публікуючи, ви погоджуєтеся, що бібліотека буде опублікована під <link>Ліцензія MIT, </link>, простими словами, це означає що нею зможе користуватися будь-хто без обмежень.",
    "noteItems": "Кожен об'єкт в бібліотеці повинен мати назву, це потрібно для пошуку та фільтрування. Наступні об'єкти бібліотеки будуть включені:",
    "atleastOneLibItem": "Будь ласка, виберіть принаймні один елемент бібліотеки, щоб почати",
    "republishWarning": "Зауважте, деякі з вибраних елементів позначені як вже опубліковані/надіслані. Ви повинні повторно надсилати елементи тільки при оновленні вже опублікованої бібліотеки чи при публікації бібліотеки."
  },
  "publishSuccessDialog": {
    "title": "Бібліотека відправлена",
    "content": "Дякуємо, {{authorName}}. Ваша бібліотека була відправлена для розгляду. Ви можете відстежувати статус<link>тут</link>"
  },
  "confirmDialog": {
    "resetLibrary": "Очистити бібліотеку",
    "removeItemsFromLib": "Видалити вибрані елементи з бібліотеки"
  },
  "imageExportDialog": {
    "header": "Експортувати зображення",
    "label": {
      "withBackground": "Тло",
      "onlySelected": "Тільки вибране",
      "darkMode": "Темний режим",
      "embedScene": "Вбудована сцена",
      "scale": "Масштабування",
      "padding": "Відступ"
    },
    "tooltip": {
      "embedScene": "Дані сцени будуть збережені в експортований файл PNG/SVG. Ця сцена може бути відновлена з нього, однак це збільшить розмір експортованого файлу."
    },
    "title": {
      "exportToPng": "Експортувати в PNG",
      "exportToSvg": "Експортувати у SVG",
      "copyPngToClipboard": "Скопіювати PNG в буфер обміну"
    },
    "button": {
      "exportToPng": "PNG",
      "exportToSvg": "SVG",
      "copyPngToClipboard": "Копіювати в буфер обміну"
    }
  },
  "encrypted": {
    "tooltip": "Ваші креслення захищені наскрізним шифруванням — сервери Excalidraw ніколи їх не побачать.",
    "link": "Допис у блозі на наскрізному шифруванні в Excalidraw"
  },
  "stats": {
    "angle": "Кут",
    "element": "Елемент",
    "elements": "Елементи",
    "height": "Висота",
    "scene": "Сцена",
    "selected": "Обрано",
    "storage": "Сховище",
    "title": "Статистика",
    "total": "Всього",
    "version": "Версія",
    "versionCopy": "Натисніть, щоб скопіювати",
    "versionNotAvailable": "Версія недоступна",
    "width": "Ширина"
  },
  "toast": {
    "addedToLibrary": "Додано до бібліотеки",
    "copyStyles": "Скопійовані стилі.",
    "copyToClipboard": "Скопіювати до буферу обміну.",
    "copyToClipboardAsPng": "Скопійовано {{exportSelection}} до буфера обміну як PNG\n({{exportColorScheme}})",
    "fileSaved": "Файл збережено.",
    "fileSavedToFilename": "Збережено в {filename}",
    "canvas": "полотно",
    "selection": "виділення",
    "pasteAsSingleElement": "Використайте {{shortcut}} для вставки самостійного зразка або використайте в текстовому редакторі",
    "unableToEmbed": "Вбудування цієї url на даний час не допускається. Підніміть питання на GitHub, щоб попросити внести URL-адресу до білого списку",
    "unrecognizedLinkFormat": "Посилання, яке ви вставили, не відповідає очікуваному формату. Будь ласка, спробуйте вставити рядок \"embed\", наданий сайтом-джерелом"
  },
  "colors": {
    "transparent": "Прозорий",
    "black": "Чорний",
    "white": "Білий",
    "red": "Червоний",
    "pink": "Рожевий",
    "grape": "Виноградний",
    "violet": "Фіолетовий",
    "gray": "Сірий",
    "blue": "Синій",
    "cyan": "Ціан",
    "teal": "Бірюзовий",
    "green": "Зелений",
    "yellow": "Жовтий",
    "orange": "Помаранчевий",
    "bronze": "Бронзовий"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "Всі ваші дані збережено локально у Вашому браузері.",
      "center_heading_plus": "Чи бажаєте перейти до Excalidraw+?",
      "menuHint": "Експорт, налаштування, мови, ..."
    },
    "defaults": {
      "menuHint": "Експорт, налаштування та багато іншого...",
      "center_heading": "Діаграми. Робити. Просто.",
      "toolbarHint": "Оберіть інструмент і почніть малювати!",
      "helpHint": "Гарячі клавіші і допомога"
    }
  },
  "colorPicker": {
    "mostUsedCustomColors": "Найбільш використовувані користувацькі кольори",
    "colors": "Кольори",
    "shades": "Тіні",
    "hexCode": "Hex-код",
    "noShades": "Немає доступних відтінків цього кольору"
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "Експортувати як зображення",
        "button": "Експортувати як зображення",
        "description": "Експорт даних сцени у вигляді зображення, з якого можна імпортувати пізніше."
      },
      "saveToDisk": {
        "title": "Зберегти на диск",
        "button": "Зберегти на диск",
        "description": "Експорт даних сцени в файл, з якого можна імпортувати пізніше."
      },
      "excalidrawPlus": {
        "title": "Excalidraw+",
        "button": "Експортувати до Excalidraw+",
        "description": "Зберегти сцену до робочого простору Excalidraw+."
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "Завантажити з файлу",
        "button": "Завантажити з файлу",
        "description": "Завантаження з файлу <bold>замінить наявний вміст</bold>.<br></br>Ви можете спочатку створити резервну копію малюнка, скориставшись одним із наведених нижче способів."
      },
      "shareableLink": {
        "title": "Завантажити з посилання",
        "button": "Замінити мій контент",
        "description": "Завантаження зовнішнього малюнка <bold>замінить ваш наявний вміст</bold>.<br></br>Ви можете спочатку створити резервну копію малюнка, скориставшись одним із наведених нижче способів."
      }
    }
  },
  "mermaid": {
    "title": "",
    "button": "",
    "description": "",
    "syntax": "",
    "preview": ""
  }
}
